import { TodoItem } from "../../mail/types/mail";
import { TodoItemResponseDTO } from "../types/apiResponse";

export function toDomainAcceptedTodo(dto: TodoItemResponseDTO): TodoItem {
    return {
        id: dto.id,
        internetMessageId: dto.internetMessageId,
        taskSummary: dto.taskSummary,
        linkedEventId: dto.linkedEventId,
        done: dto.done,
        checkedDate: dto.checkedDate,
        isUserAccepted: true,
    };
}
